import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_material_info_us()
})

// $(document).ready(function () {})

$(window).on('scroll', function () {
  // jQuery code goes here
  dhsv_vc_material_info_us()
})

function dhsv_vc_material_info_us() {
  let scrollTop = $(document).scrollTop(),
    triggerPoint = scrollTop + window.innerHeight / 2

  $('.dhsv_vc_material_info_us').each(function () {
    let offsetTop = $(this).offset().top,
      $bars = $(this).find('.js-animated-bar')

    if (triggerPoint >= offsetTop && !$(this).hasClass('animated')) {
      $(this).addClass('animated')
      $bars.each(function () {
        let width = $(this).attr('data-width')
        $(this).animate({ width: width + '%' }, 500)
      })
    }
  })
}
